/* G9 — product badges: stamp each badge with a slug of its own label.
   Serena, 4 Sep 2026. Paired with sections/stl-product-badges.liquid, which
   emits the colour and order rules keyed on the attribute this file sets.

   WHY JS. CSS cannot select on text content, and the badge label is the only
   thing distinguishing "Natural Fibres" from "New In" — Madrid gives both the
   same `badge--custom` class and no per-label hook. Adding one in Liquid would
   be eight edits across four core files (product-card, product-card-horizontal,
   main-product, featured-product — each has a list and a non-list branch), all
   upgrade debt, and it still would not cover badges injected after load.

   Also clears `aria-hidden="true"`, which Madrid puts on every badge so screen
   readers never hear "Sale" or "Sold Out" (defect D3). The badge is meaningful
   content, not decoration.
*/
(function () {
  'use strict';

  /* Madrid's own badge modifiers, NOT a bare `.badge` — that class is generic
     enough that a third-party app could use it, and a stray match would be
     silently recoloured by the section's rules. These three cover every product
     badge Madrid renders, wherever it renders them, so the hook follows the
     badges rather than the containers they happen to sit in today. */
  var SELECTOR = '.badge--custom, .badge--sale, .badge--soldout';

  /* Mirrors Liquid's `| handle`: lower case, non-alphanumerics to single
     hyphens, trimmed. "Natural Fibres" -> "natural-fibres", "Sold Out" ->
     "sold-out". The section slugs its labels the same way, so the two meet. */
  function slugify(text) {
    return String(text)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function stamp(badge) {
    if (!badge || badge.nodeType !== 1) return;

    /* The Sale badge nests a <span> holding the discount percentage, which is
       per-product and must not become part of the slug. Read only the direct
       text nodes so "Sale 30%" still slugs as "sale". */
    var own = '';
    for (var i = 0; i < badge.childNodes.length; i++) {
      var node = badge.childNodes[i];
      if (node.nodeType === 3) own += node.nodeValue;
    }
    var label = slugify(own.trim() || badge.textContent.trim());
    if (!label) return;

    if (badge.getAttribute('data-stl-badge') !== label) {
      badge.setAttribute('data-stl-badge', label);
    }

    /* D3: badges are content, not decoration. */
    if (badge.getAttribute('aria-hidden') === 'true') {
      badge.removeAttribute('aria-hidden');
    }
  }

  function stampWithin(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTOR)) stamp(root);
    var found = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < found.length; i++) stamp(found[i]);
  }

  /* The PDP badges are emitted by the section at the END of <body> (see
     sections/stl-product-badges.liquid) and must sit on the gallery image. Madrid
     renders the gallery TWICE — a desktop copy and a mobile copy, one hidden
     either side of 750px — so a clone goes into the first media item of EACH, and
     the original is removed. `.product__media-item:first-child` is
     `position: relative`, which is what anchors the absolute placement.

     Into the media ITEM rather than the slide's inner `.product__media`, so that
     on mobile the badge stays put over the gallery instead of scrolling away with
     the first slide. */
  function placePdpBadges() {
    var source = document.querySelector('.stl-pdp-badges');
    if (!source || source.dataset.stlPlaced) return;

    var lists = document.querySelectorAll('.product__media-list');
    if (!lists.length) return;

    var placed = 0;
    for (var i = 0; i < lists.length; i++) {
      var first = lists[i].querySelector('.product__media-item');
      if (!first || first.querySelector('.stl-pdp-badges')) continue;
      var copy = source.cloneNode(true);
      copy.dataset.stlPlaced = '1';
      first.appendChild(copy);
      stampWithin(copy);
      placed++;
    }
    if (placed) source.remove();
  }

  function init() {
    stampWithin(document.body);
    placePdpBadges();

    /* Recommendation carousels, the quick-add sheet and load-more all inject
       cards after page load, so a one-shot pass on DOMContentLoaded misses them.
       Observing is not an optimisation here — it is the only way those surfaces
       are ever covered. Same lesson as stl-carousel.js. */
    if (!('MutationObserver' in window)) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) stampWithin(added[j]);
      }
      /* The gallery is re-rendered on a variant change, which drops the clones,
         and the recommendation carousels inject cards long after load. */
      placePdpBadges();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
